// extracted by mini-css-extract-plugin
module.exports = {"dialog":"ProductSellerPromotionDialog_dialog__r8Tkj"};